
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"31","height":"31","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M15.813 20.563h.806c.805 0 1.475-.749 1.475-1.653 0-1.124-.384-1.343-1.017-1.576l-1.252-.452v3.681h-.012z","fill":"#292D32"}}),_c('path',{attrs:{"d":"M14.845 2.454C8.001 2.48 2.458 8.28 2.482 15.41c.025 7.13 5.593 12.903 12.438 12.878 6.845-.026 12.387-5.826 12.362-12.956-.024-7.13-5.592-12.89-12.437-12.878zm2.84 13.046c.967.349 2.27 1.098 2.27 3.41 0 1.99-1.501 3.59-3.336 3.59h-.806v.75c0 .53-.422.969-.93.969-.509 0-.93-.44-.93-.969v-.75h-.447c-2.034 0-3.683-1.782-3.683-3.977 0-.53.422-.97.93-.97.509 0 .93.44.93.97 0 1.123.819 2.04 1.823 2.04h.447v-4.365L12.08 15.5c-.967-.349-2.27-1.098-2.27-3.41 0-1.99 1.501-3.59 3.336-3.59h.806v-.75c0-.53.422-.969.93-.969.509 0 .93.44.93.969v.75h.447c2.034 0 3.683 1.782 3.683 3.977 0 .53-.422.97-.93.97-.509 0-.93-.44-.93-.97 0-1.123-.819-2.04-1.823-2.04h-.447v4.366l1.873.697z","fill":"#292D32"}}),_c('path',{attrs:{"d":"M11.683 12.103c0 1.124.385 1.343 1.017 1.576l1.252.452v-3.694h-.806c-.806 0-1.463.749-1.463 1.666z","fill":"#292D32"}})])
          )
        }
      }
    